import { localeCodeToLocaleIdentifier } from '@billy/design-system'

import { ZervantLocale } from '@features/invoices/enums/zervantLocale'

import { CustomerOptionalItem } from '../enums/customerOptionalItem'

interface GetCustomerFormInitialOptionalItemsProps {
  customerCurrency?: string
  customerLanguage?: ZervantLocale
  userLocale: string
}

// Show language & currency fields if customer's locale differs from account default
// or in case if currency is changed
export const getCustomerFormInitialOptionalItems = ({
  customerCurrency,
  customerLanguage,
  userLocale,
}: GetCustomerFormInitialOptionalItemsProps): CustomerOptionalItem[] => {
  const isLanguageDifferent = localeCodeToLocaleIdentifier(customerLanguage) !== userLocale
  const isCurrencySet = !!customerCurrency

  return isLanguageDifferent || isCurrencySet ? [CustomerOptionalItem.LanguageAndCurrency] : []
}
